import { useEffect, useState } from "react"
import { IoMdMenu } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import { Logo } from "../../assets/LandingImages/LogoIcon";
import useMousePosition from "../LandingPage/MousePosition";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [show, setShow] = useState(true);
  const [showDrop, setShowDrop] = useState(false);

  const navigate = useNavigate();

  const [lastScrollY, setLastScrollY] = useState(0);
  const mousePosition = useMousePosition();
  useEffect(()=> {
    if (mousePosition.y <= 94) {
      console.log("yes")
      setShow(true)
    }
  },[mousePosition.y])
  const triggerDrop = () => {
    setShowDrop(prev => !prev);
  }
  const controlNavbar = () => {
    if (window.scrollY > lastScrollY) {
      setShow(false);
      setShowDrop(false);
    } else {
      setShow(true);
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {

    
    window.addEventListener('scroll', controlNavbar);
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  const handleClick = () => {
    navigate('/login', 
    {state : {signupActive : false}}) 
  }
  return (
    <nav className={`navbar ${!show && 'hide-navbar relative'} `} style={{
      scrollBehavior: 'smooth'
    }}>
      <label className="ml-4 flex justify-center pl-2"><Logo /></label>
      <div className="nav-flex hidden lg:flex ">
        <label><a href="/">Home</a></label>
        <label><a href="/downloads">Downloads</a></label>
        <label><a href="#contact-us">Contact Us</a></label>
        <button className="button login-button" onClick={handleClick}>Log In</button>
      </div>
      <i className=" block lg:hidden self-center mr-2" onClick={triggerDrop}>
        {showDrop ? <IoCloseOutline size={32} /> : <IoMdMenu size={32} />}
      </i>
      {show && showDrop && <div className=" animate-open p-4 top-full absolute w-full flex flex-col items-center gap-2 font-light bg-[#F1F3F7] text-lg">
        <label><a href="/">Home</a></label>
        <label><a href="/downloads">Downloads</a></label>
        <label><a href="#contact-us">Contact Us</a></label>
        <button className="button login-button" onClick={handleClick}>Log In</button>

      </div>}
    </nav>
  )
}

export default Navbar